import { GAME_CONFIG } from '../utils/constants.js';
import { Explosion } from './explosion.js';

export class Asteroid {
    constructor(game) {
        this.game = game;
        this.canvas = document.getElementById('gameCanvas');

        const sprites = game.assetManager.getSprite('asteroids');
        this.sprite = (sprites && sprites.length > 0)
            ? sprites[Math.floor(Math.random() * sprites.length)]
            : document.createElement('canvas');

        this.reset();
    }

    reset() {
        const cfg = GAME_CONFIG.ASTEROID;
        this.width = cfg.SIZE_MIN + Math.random() * (cfg.SIZE_MAX - cfg.SIZE_MIN);
        this.height = this.width;
        this.x = Math.random() * this.canvas.width;
        this.y = -this.height;
        this.speed = cfg.MIN_SPEED + Math.random() * (cfg.MAX_SPEED - cfg.MIN_SPEED);
        this.drift = (Math.random() - 0.5) * 1.2;
        this.health = cfg.HEALTH;
        this.rotation = Math.random() * Math.PI * 2;
        this.rotationSpeed = (Math.random() - 0.5) * cfg.ROTATION_SPEED;
        this.dead = false;
    }

    update(gameState) {
        const slowFactor = gameState.bulletTimeActive ? GAME_CONFIG.POWERUP.BULLET_TIME_SPEED_FACTOR : 1;
        this.y += this.speed * slowFactor;
        this.x += this.drift * slowFactor;
        this.rotation += this.rotationSpeed * slowFactor;
    }

    draw(ctx) {
        ctx.save();
        ctx.translate(this.x, this.y);
        ctx.rotate(this.rotation);
        ctx.drawImage(this.sprite, -this.width / 2, -this.height / 2, this.width, this.height);
        ctx.restore();
    }

    takeDamage(amount, gameState) {
        if (this.dead) return false;
        this.health -= amount;
        if (this.health <= 0) {
            this.dead = true;
            gameState.score += GAME_CONFIG.ASTEROID.SCORE;
            const scoreElem = document.getElementById('score');
            if (scoreElem) scoreElem.textContent = gameState.score;
            this.explode(gameState);
            return true;
        }
        return false;
    }

    explode(gameState) {
        const explosion = this.game.objectPools?.getFromPool('explosions') ||
            new Explosion(this.x, this.y, this.game.assetManager);
        explosion.reset(this.x, this.y);
        gameState.explosions.push(explosion);
    }
}

export default Asteroid;
